'use client';

import StarFilled from '@carvana/ds-icons/StarFilledCvna';
import { brand } from '@carvana/ds-styles';
import { useMemo } from 'react';
import {
  Card,
  Date,
  Info,
  Location,
  Rating,
  Text,
  User
} from './Reviews.styles';

type OwnProps = {
  date: string;
  location: string;
  rating: number;
  text: string;
  user: string;
};

export default function ReviewCard({
  date,
  location,
  rating,
  text,
  user
}: OwnProps) {
  const stars = useMemo(
    () => Array.from({ length: rating }, (_, index) => index + 1),
    [rating]
  );

  return (
    <Card>
      <Rating>
        {stars.map(index => (
          <StarFilled key={index} color={brand.tertiary} size={16} />
        ))}
      </Rating>
      <Text>{text}</Text>
      <div>
        <Info>
          <User>{user}</User>
          <Location>{location}</Location>
        </Info>
        <Date>{date}</Date>
      </div>
    </Card>
  );
}
